module.exports = __webpack_public_path__ + "img/bosnia-flag.adc226e6.png";